import { render, staticRenderFns } from "./fail-order.vue?vue&type=template&id=77f6cb20&"
import script from "./fail-order.vue?vue&type=script&lang=js&"
export * from "./fail-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports